<template>
  <div class="loader-container">
    <div class="loader">
      <div class="spinner"></div>
      <p v-if="message" class="loader-message">{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimpleLoader',
  props: {
    message: {
      type: String,
      default: 'Cargando...'
    }
  }
}
</script>

<style scoped>
.loader-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loader {
  text-align: center;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loader-message {
  color: #666;
  font-size: 14px;
  margin: 0;
  font-family: Arial, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/components/Loader.vue